export default __webpack_public_path__ + "static/media/bm-agri.8cecf673.jpg";